var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationOutline = function SvgLocationOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 20"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.5 8a6.5 6.5 0 1 0-13 0c0 1.44.48 2.77 1.27 3.85h-.01L8 19l5.24-7.15h-.01A6.5 6.5 0 0 0 14.5 8"
  })));
};
export default SvgLocationOutline;